export const LISTE_CLIENT = {
  titlePage: 'Liste des clients',
  btnCreate: 'Créer un point de vente',
  liste: {
    table: {
      colonneClient: 'Client',
      colonneType: 'Type',
      colonneAdresse: 'Adresse',
      colonneTelephone: 'Téléphone',
      colonneEmail: 'Email',
      colonneDetail: 'Detail',
      colonneSociete: 'Société',
    },
    typeClient: {
      enseigne: 'Enseigne',
      pointVente: 'Point de vente',
      groupe: 'Groupe',
    },
  },
};

export const CREER_CLIENT = {
  titlePagePDV: 'Créer un point de vente',
  labelChamp: {
    libelleEnseigne: 'Nom de l’enseigne',
    libelle: 'Nom du groupe',
    libellePDV: 'Nom du point de vente',
    adresse: 'Adresse',
    adressePDV: 'Adresse du point de vente',
    marque: 'Marque',
    secteurActivite: 'Secteur d’activité',
    telephone: 'Téléphone',
    email: 'Email',
    siren: 'Siren',
    referenceHavas: 'Référence Havas',
    adresseFacturation: 'Adresse Facturaction',
    checkboxAdresseDifference: 'L’adresse de facturation est différente de l’adresse postale.',
    groupe: 'Groupe',
    enseigne: 'Enseigne',
    applicationTva: 'Application TVA',
  },
  labelContact: 'Contacts',
  btnAjoutContact: 'Ajouter un contact',
  labelPJ: 'Pièces jointes',
  btnAjoutPJ: 'Ajouter une pièce jointe',
  btnValiderPDV: 'Créer le point de vente',
  aucunContact: 'Aucun contact',
  aucunPiece: 'Aucune piéce jointe',
  modifierContact: 'Modifier',
  suppPj: 'Supprimer',
};
export const MODIFIER_CLIENT = {
  titlePage: 'Modifier un groupe',
  titlePageEnseigne: 'Modifier une enseigne',
  titlePagePDV: 'Modifier un point de vente',
  btnValider: 'Modifier le groupe',
  btnValiderEnseigne: 'Modifier l’enseigne',
  btnValiderPDV: 'Modifier le point de vente',
};

export const AJOUT_CONTACT = {
  titlePage: 'Créer un contact',
  titlePageModif: 'Modifier un contact',
  labelChamp: {
    civilite: 'Civilité',
    nom: 'Nom',
    prenoms: 'Prénom',
    telephone: 'Téléphone',
    email: 'Email',
    service: 'Service',
    fonction: 'Fonction',
    newCivilite: 'créer une civilité',
    recherche: 'rechercher une civilité',
  },
  btnValider: 'Créer le contact',
  btnModifier: 'Modifier le contact',
  msgErreur: 'Une erreur est survenue lors de l\'enregistrement du contact',
};
